import { createSlice } from "@reduxjs/toolkit"
import { formatMoney } from "../../utils"

const percentageDifference = (newValue, oldValue) => {
  if (oldValue <= 0 || newValue <= 0) return null
  return Math.round(((newValue - oldValue) / oldValue) * 10000) / 100
}

const initialState = {
  expensesTotalStats: [],
  expensesArr: [],
  expensesAllData: {},
  totalExpenses: 0,
  previousWeekTotals: {}
}

export const { actions, reducer } = createSlice({
  name: "expenses",
  initialState,
  reducers: {
    setExpensesTotalStats: (state, action) => {
      state.expensesTotalStats = action.payload
    },
    setExpensesAllData: (state, action) => {
      state.expensesAllData = action.payload
    },
    setExpensesArr: (state, action) => {
      state.expensesArr = action.payload
    },
    setTotalExpenses: (state, action) => {
      state.totalExpenses = action.payload
    },
    setPreviousWeekTotals: (state, action) => {
      state.previousWeekTotals = action.payload
    },

    changeExpensesData: (state, action) => {
      const changeElement = state.expensesArr.map((el) => {
        if (el.id === action.payload.id) {
          return {
            ...el,
            expenses: action.payload.expenses
          }
        }
        return el
      })

      const calculateTotalByLabel = (label) => {
        return changeElement.reduce((acc, el) => {
          const expense = (el.expenses || []).find((e) => e.label_name === label)
          return acc + (parseFloat(expense?.amount) || 0)
        }, 0)
      }

      const newExpensesTotalStats = state.expensesTotalStats.map((el) => {
        if (el.name === "Fixed Expenses") {
          return el
        }

        const newTotal = calculateTotalByLabel(el.name)
        const prevTotal = state.previousWeekTotals[el.name]
        const percentageChange = prevTotal != null ? percentageDifference(newTotal, prevTotal) : el.percentageChange
        return { ...el, count: formatMoney(newTotal), percentageChange }
      })

      const calculatedTotalExpenses = changeElement.reduce((acc, cur) => {
        const currentTotal = (cur.expenses || []).reduce(
          (sum, expense) => sum + (parseFloat(expense.amount) || 0),
          0
        )
        return acc + currentTotal + (parseFloat(cur.fixed_expenses) || 0)
      }, 0)

      state.expensesArr = changeElement
      state.expensesTotalStats = newExpensesTotalStats
      state.totalExpenses = calculatedTotalExpenses
    },

    resetPayroll: (state) => {
      state.expensesTotalStats = []
      state.expensesArr = []
      state.expensesAllData = {}
      state.totalExpenses = 0
      state.previousWeekTotals = {}
    }
  }
})

export default reducer
